class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.productShowCount = this.dataset.productShowCount;
      this.products = this.querySelectorAll('.product-grid li');
      this.cartItems = document.querySelector('cart-items');
      if(!this.cartItems) return;
      this.update();
    }

    update() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if (cart.status) {
                this.handleErrorMessage(cart.description);
                return;
            }
            let productCount = 0;
            this.products.forEach(product => {
                if (cart.items.find(line_item => line_item.product_id == product.dataset.productId)) {
                    product.classList.add('hidden');
                } else {
                    product.classList.remove('hidden');
                    productCount++;
                    if(productCount > this.productShowCount) product.classList.add('hidden');
                }
            });
        })
    }
}

customElements.define('cart-recommendations', CartRecommendations);